<template>
  <BottomSheet :show="show" @close="$emit('close')">
    <div class="flex justify-center -mt-12 mb-2">
      <div class="bg-primary rounded-full w-20 h-20 flex items-center justify-center shadow-lg border-4 border-white">
        <i class="bx bx-check text-white text-4xl"></i>
      </div>
    </div>
    <div class="px-6 text-center flex flex-col min-h-[260px] h-full">
      <h2 class="text-2xl font-bold mb-2 mt-2">Candidatura inviata!</h2>
      <p v-if="user" class="text-primary font-semibold mb-2">
        Ti sei candidato come {{ user.nome }} {{ user.cognome }}
      </p>
      <p class="text-gray-500 mb-6">Hai completato la candidatura.<br>Riceverai aggiornamenti via email o WhatsApp.</p>
      <div class="mt-auto pb-8">
        <CuButton primary class="w-full" @click="$emit('close')">Chiudi</CuButton>
      </div>
    </div>
  </BottomSheet>
</template>

<script>
import BottomSheet from './BottomSheet.vue'
import CuButton from '../cu/CuButton.vue'

export default {
  name: "CandidateSuccessModal",
  components: { BottomSheet, CuButton },
  props: {
    show: { type: Boolean, default: false },
    user: { type: Object, default: null }
  }
}
</script>
